var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneFilledSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M575,375v48.1c0,101.1-84.7,182.7-185.7,176.6s-164.3-81.6-164.3-174.7v-50c0-13.8-11.2-25-25-25h0c-13.8,0-25,11.2-25,25v50c0,114.5,86.1,210.7,199.9,223.5,0,0,.1,0,.1.1v51.2c0,0,0,.1-.1.1h-74.9c-13.8,0-25,11.2-25,25h0c0,13.8,11.2,25,25,25h200c13.8,0,25-11.2,25-25h0c0-13.8-11.2-25-25-25h-74.9c0,0-.1,0-.1-.1v-51.2c0,0,0-.1.1-.1,113.8-12.8,199.8-109,199.9-223.5v-50c0-13.8-11.2-25-25-25h0c-13.8,0-25,11.2-25,25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,550c69,0,125-56,125-125v-250c0-69-56-125-125-125s-125,56-125,125v250c0,69,56,125,125,125Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    className: "st0",
    width: 800,
    height: 800
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneFilledSvgrepoCom);
export default __webpack_public_path__ + "static/media/microphone-filled-svgrepo-com.a1299eeb1f140dd1e4fb35fd8eb8ba0a.svg";
export { ForwardRef as ReactComponent };